import React, { useState } from "react";
import { CheckCircle } from "@mui/icons-material";
import BASE_URL from "../config/apiConfig";
import "./NewsletterSubscription.css";

const NewsletterSubscription = () => {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailPattern.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/api/subscribe`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setSuccess(true);
        setEmail("");
        setError("");
      } else {
        const errorData = await response.json();
        setError(errorData.message || "Subscription failed. Please try again.");
      }
    } catch (error) {
      console.error("Error during subscription:", error);
      setError("An error occurred. Please try again.");
    }
  };

  const handleCloseSuccess = () => {
    setSuccess(false);
  };

  return (
    <section className="farmology-newsletter">
      <div className="newsletter-container">
        <div className="newsletter-card">
          <div className="newsletter-content">
            <div className="newsletter-eyebrow">
              <span className="newsletter-eyebrow-line"></span>
              STAY CONNECTED
            </div>

            <h2>
              Subscribe to our
              <span> newsletter.</span>
            </h2>

            <p>
              Stay updated with the latest news and offers from our agritech
              solutions.
            </p>
          </div>

          <form
            className="newsletter-form"
            onSubmit={handleSubscribe}
            noValidate
          >
            <div className="newsletter-input-wrap">
              <input
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (error) setError("");
                }}
                placeholder="Enter your email address"
                aria-label="Email address"
                required
              />
            </div>

            <button type="submit" className="newsletter-submit">
              Subscribe
              <span aria-hidden="true">↗</span>
            </button>
          </form>

          {error && (
            <p className="newsletter-error" role="alert">
              {error}
            </p>
          )}

          {success && (
            <div className="newsletter-success" role="status">
              <span className="newsletter-success-icon">
                <CheckCircle />
              </span>

              <div>
                <strong>Successfully subscribed!</strong>
                <button
                  type="button"
                  onClick={handleCloseSuccess}
                  aria-label="Dismiss success message"
                >
                  ×
                </button>
              </div>
            </div>
          )}

          <div className="newsletter-bottom">
            <span>FARMOLOGY</span>
            <span className="newsletter-bottom-line"></span>
            <span>SMART AGRICULTURE</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterSubscription;
